export default __webpack_public_path__ + "c9f7853225b51938c565b912fba21964.png";